import axiosInstance from "../utilities/axiosSetup";

export const get_attributes_by_engagement_id = async (engagement_id) => {
  let response = await axiosInstance.get(
    import.meta.env.VITE_API_URL + "/get-attributes-by-engagement-id",
    {
      params: {
        engagement_id: engagement_id,
      },
      headers: {
        Authorization: "Bearer " + sessionStorage.getItem("authToken"),
      },
    }
  );
  return response.data.data;
};

export const list_call_logs = async (filters = {}) => {
  let response = await axiosInstance.get(
    import.meta.env.VITE_API_URL + "/list-call-logs",
    {
      params: filters,
      headers: {
        Authorization: "Bearer " + sessionStorage.getItem("authToken"),
      },
    }
  );
  return response.data;
};

export const get_data_to_download = async (filters = {}) => {
  let response = await axiosInstance.get(
    import.meta.env.VITE_API_URL + "/get-data-to-download",
    {
      params: filters,
      headers: {
        Authorization: "Bearer " + sessionStorage.getItem("authToken"),
      },
    }
  );
  return response.data;
};

// New function for chunked download with streaming support
export const get_data_to_download_chunked = async (
  filters = {},
  onProgress = null
) => {
  const response = await fetch(
    `${
      import.meta.env.VITE_API_URL
    }/get-data-to-download-chunked?${new URLSearchParams(filters)}`,
    {
      headers: {
        Authorization: "Bearer " + sessionStorage.getItem("authToken"),
      },
    }
  );

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let allData = [];

  while (true) {
    const { done, value } = await reader.read();

    if (done) break;

    buffer += decoder.decode(value, { stream: true });

    // Try to parse complete JSON objects from buffer
    try {
      // Look for complete JSON structure
      if (buffer.includes('{"data":[') && buffer.includes("]}")) {
        const jsonStr = buffer.substring(
          buffer.indexOf('{"data":['),
          buffer.lastIndexOf("]}") + 2
        );
        const parsed = JSON.parse(jsonStr);
        allData = parsed.data;

        // Call progress callback if provided
        if (onProgress) {
          onProgress(allData.length);
        }
      }
    } catch (e) {
      // Continue accumulating buffer if JSON is incomplete
    }
  }

  return { data: allData };
};

export const list_customers_report = async () => {
  try {
    const { data } = await axiosInstance.get(
      import.meta.env.VITE_API_URL + "/list-customers-report",
      {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return data;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const list_interpreters_report = async () => {
  try {
    const { data } = await axiosInstance.get(
      import.meta.env.VITE_API_URL + "/list-interpreters-report",
      {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return data;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const reboot_rds = async () => {
  try {
    const { data } = await axiosInstance.post(
      import.meta.env.VITE_API_URL + "/reboot-rds",
      {},
      {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const get_interpreters_to_download_chunked = async (
  filters = {},
  onProgress = null
) => {
  const response = await fetch(
    `${
      import.meta.env.VITE_API_URL
    }/get-interpreters-to-download-chunked?${new URLSearchParams(filters)}`,
    {
      headers: {
        Authorization: "Bearer " + sessionStorage.getItem("authToken"),
      },
    }
  );
  console.log(response);
  if (!response.ok) {
    throw response.statusText;
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let allData = [];

  while (true) {
    const { done, value } = await reader.read();

    if (done) break;

    buffer += decoder.decode(value, { stream: true });

    // Try to parse complete JSON objects from buffer
    try {
      // Look for complete JSON structure
      if (buffer.includes('{"data":[') && buffer.includes("]}")) {
        const jsonStr = buffer.substring(
          buffer.indexOf('{"data":['),
          buffer.lastIndexOf("]}") + 2
        );
        const parsed = JSON.parse(jsonStr);
        allData = parsed.data;

        // Call progress callback if provided
        if (onProgress) {
          onProgress(allData.length);
        }
      }
    } catch (e) {
      // Continue accumulating buffer if JSON is incomplete
    }
  }

  return { data: allData };
};

export const get_customers_to_download_chunked = async (
  filters = {},
  onProgress = null
) => {
  const response = await fetch(
    `${
      import.meta.env.VITE_API_URL
    }/get-customers-to-download-chunked?${new URLSearchParams(filters)}`,
    {
      headers: {
        Authorization: "Bearer " + sessionStorage.getItem("authToken"),
      },
    }
  );
  console.log(response);
  if (!response.ok) {
    throw response.statusText;
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let allData = [];

  while (true) {
    const { done, value } = await reader.read();

    if (done) break;

    buffer += decoder.decode(value, { stream: true });

    // Try to parse complete JSON objects from buffer
    try {
      // Look for complete JSON structure
      if (buffer.includes('{"data":[') && buffer.includes("]}")) {
        const jsonStr = buffer.substring(
          buffer.indexOf('{"data":['),
          buffer.lastIndexOf("]}") + 2
        );
        const parsed = JSON.parse(jsonStr);
        allData = parsed.data;

        // Call progress callback if provided
        if (onProgress) {
          onProgress(allData.length);
        }
      }
    } catch (e) {
      // Continue accumulating buffer if JSON is incomplete
    }
  }

  return { data: allData };
};
